import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import { PartyPopper, Clock, XCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PagamentoRetornoPage = ({ tipo }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(null);

  useEffect(() => {
    const verifyPayment = async () => {
      // Tentar obter payment_id do sessionStorage ou dos parâmetros da URL
      const paymentId = sessionStorage.getItem('pending_payment_id');
      const externalReference = searchParams.get('external_reference');
      
      if (paymentId) {
        try {
          const response = await axios.get(`${API}/payments/${paymentId}/status`);
          setPaymentStatus(response.data.status);
          
          // Limpar dados temporários se pagamento confirmado
          if (response.data.status === 'CONFIRMED' || response.data.status === 'RECEIVED') {
            sessionStorage.removeItem('pending_payment_id');
            sessionStorage.removeItem('cadastroData');
            sessionStorage.removeItem('planoSelecionado');
          }
        } catch (err) {
          console.error('Erro ao verificar pagamento:', err);
        }
      }
      
      setVerifying(false);
    };

    verifyPayment();
  }, [searchParams]);

  // Determinar o conteúdo baseado no tipo da página
  const getContent = () => {
    if (verifying) {
      return {
        icon: <Loader2 className="w-20 h-20 animate-spin" style={{ color: '#6A68A3' }} />,
        title: 'Verificando pagamento...',
        message: 'Aguarde enquanto confirmamos seu pagamento.',
        showLoginButton: false,
        showRetryButton: false
      };
    }

    // Se o pagamento foi confirmado via API, mostrar sucesso
    if (paymentStatus === 'CONFIRMED' || paymentStatus === 'RECEIVED') {
      return {
        icon: <PartyPopper className="w-20 h-20" style={{ color: '#68AAB0' }} />,
        title: 'Pagamento Confirmado!',
        message: 'Seu pagamento foi processado com sucesso.',
        instruction: 'Faça o seu login e comece a utilizar o sistema.',
        showLoginButton: true,
        showRetryButton: false
      };
    }

    switch (tipo) {
      case 'sucesso':
        return {
          icon: <PartyPopper className="w-20 h-20" style={{ color: '#68AAB0' }} />,
          title: 'Pagamento Realizado!',
          message: 'Seu pagamento está sendo processado.',
          instruction: 'Em alguns instantes você poderá fazer login no sistema.',
          showLoginButton: true,
          showRetryButton: false
        };
      case 'pendente':
        return {
          icon: <Clock className="w-20 h-20" style={{ color: '#F5A623' }} />,
          title: 'Pagamento Pendente',
          message: 'Seu pagamento está aguardando confirmação.',
          instruction: 'Você receberá um e-mail assim que o pagamento for confirmado.',
          showLoginButton: true,
          showRetryButton: true
        };
      case 'falha':
        return {
          icon: <XCircle className="w-20 h-20" style={{ color: '#F75C6F' }} />,
          title: 'Pagamento não Realizado',
          message: 'Houve um problema com seu pagamento.',
          instruction: 'Por favor, tente novamente ou escolha outra forma de pagamento.',
          showLoginButton: false,
          showRetryButton: true
        };
      default:
        return {
          icon: <Clock className="w-20 h-20" style={{ color: '#6A68A3' }} />,
          title: 'Status do Pagamento',
          message: 'Verificando status do seu pagamento...',
          showLoginButton: true,
          showRetryButton: true
        };
    }
  };

  const content = getContent();

  return (
    <div className="pagamento-page">
      <Header />
      <main className="pagamento-main">
        <div className="success-container">
          <div className="success-icon">
            {content.icon}
          </div>
          <h1 className="success-title">
            {content.title.includes('Livrum') ? (
              <>Bem-vindo(a) ao <span className="text-accent">Livrum</span>!</>
            ) : (
              content.title
            )}
          </h1>
          <p className="success-message">
            {content.message}
          </p>
          {content.instruction && (
            <p className="success-instruction">
              {content.instruction}
            </p>
          )}
          <div className="success-actions">
            {content.showLoginButton && (
              <Button 
                className="btn-primary-custom btn-large"
                onClick={() => navigate('/login')}
                data-testid="login-button"
              >
                Fazer Login
              </Button>
            )}
            {content.showRetryButton && (
              <Button 
                className="btn-secondary-custom"
                onClick={() => navigate('/escolher-plano')}
                data-testid="retry-button"
              >
                {tipo === 'falha' ? 'Tentar Novamente' : 'Escolher Outro Plano'}
              </Button>
            )}
            <Button 
              className="btn-secondary-custom"
              onClick={() => navigate('/')}
              data-testid="home-button"
            >
              Voltar à Página Inicial
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PagamentoRetornoPage;
